<template lang="pug">
    div(class="pt-5 pb-12 px-3 bg-black")
        div(class="lg:container")
            div(v-if="!isSimpleMode" class="mb-6 lg:hidden" )
                nuxt-link(:to="{ name: 'home' }")
                    Logo(
                        class="w-full h-full mx-auto"
                        style="max-width:225px;min-height:35px;"
                        isLazy
                        isLight
                    )

            div(v-if="!isSimpleMode" class="lg:hidden")
                SocialMedia(class="mb-5")

            div(v-if="$config.runtime.theme.newsletter.enabled && !isSimpleMode" class="lg:hidden")
                Subscribe(
                    formName="footer-email-subscribe"
                    class="mt-4 mx-4 mb-5"
                )

            div(
                class="flex flex-wrap justify-center items-center space-x-4 mb-3"
            )
                //- mr-2 required for IE11 space-x-4 handles it for modern browsers
                img(
                    src="~/assets/footer/visa.svg"
                    alt="Visa"
                    width="43"
                    height="13"
                    class="inline-block mr-2 mb-2"
                    style="width: 43px;height:13px;"
                    loading="lazy"
                )
                img(
                    src="~/assets/footer/mastercard.svg"
                    alt="Mastercard"
                    width="33"
                    height="20"
                    class="inline-block mr-2 mb-2"
                    style="width: 33px;height:20px;"
                    loading="lazy"
                )
                img(
                    src="~/assets/footer/american_express.svg"
                    alt="American Express"
                    width="60"
                    height="15"
                    class="inline-block mr-2 mb-2"
                    style="width: 60px;height:15px;"
                    loading="lazy"
                )
                img(
                    src="~/assets/footer/discover_card.svg"
                    alt="Discover"
                    width="87"
                    height="14"
                    class="inline-block mr-2 mb-2"
                    style="width: 87px;height:14px;"
                    loading="lazy"
                )
                img(
                    v-if="$paypal.enabled"
                    src="~/assets/footer/paypal.svg"
                    alt="Paypal"
                    width="59"
                    height="16"
                    class="inline-block mr-2 mb-2"
                    style="width: 59px;height:16px;"
                    loading="lazy"
                )
                img(
                    v-if="$paypal.enabled"
                    src="~/assets/footer/paypal-credit.svg"
                    alt="Paypal Credit"
                    width="41"
                    height="17"
                    class="inline-block mr-2 mb-2"
                    style="width: 41px;height:17px;"
                    loading="lazy"
                )
                img(
                    v-if="$stripe.enabled"
                    src="~/assets/footer/google_pay.svg"
                    alt="Google Pay"
                    width="45"
                    height="19"
                    class="inline-block mr-2 mb-2"
                    style="width: 45px;height:19px;"
                    loading="lazy"
                )
                img(
                    v-if="$stripe.enabled"
                    src="~/assets/footer/apple_pay.svg"
                    alt="Apple Pay"
                    width="45"
                    height="18"
                    class="inline-block mr-2 mb-2"
                    style="width: 45px;height:18px;"
                    loading="lazy"
                )
                img(
                    v-if="$affirm.enabled"
                    src="~/assets/footer/affirm.svg"
                    alt="Affirm"
                    width="45"
                    height="19"
                    class="inline-block -mt-1 mb-2"
                    style="width: 45px;height:19px;"
                    loading="lazy"
                )

            div(class="flex flex-col justify-center text-gray-light text-xs text-center lg:flex-row")
                div
                    | &copy; {{ new Date().getFullYear() }} {{ $config.runtime.siteName }}.  All rights reserved.

                div(class="flex justify-center flex-col md:flex-row")
                    template(v-for="(link, index) in links")
                        nuxt-link(
                            :to="link.path"
                            class="text-inherit whitespace-nowrap border-gray-dark mt-1 md:mt-2 lg:mt-0"
                            :class="{ 'md:border-l md:ml-3 md:pl-3': index > 0, 'lg:border-l-none lg:ml-2 lg:pl-2': index === 0 }"
                        ) {{ link.text }}

            p(
                v-if="$config.runtime.theme.footer.legalBar.disclaimer"
                v-html="$config.runtime.theme.footer.legalBar.disclaimer"
                class="mt-2 text-gray-light text-xs text-center"
            )

</template>

<script>
import Logo from '@/components/logo'
import AffirmLogo from '@/integrations/affirm/affirmLogo'
import SocialMedia from './socialMedia'
const Subscribe = () =>
    import(/* webpackChunkName: "newsletter-subscribe" */ '@/components/subscribe/')

export default {
    name: 'LegalBar',
    components: {
        Logo,
        AffirmLogo,
        SocialMedia,
        Subscribe,
    },
    computed: {
        isSimpleMode() {
            return this.$store.state.isSimpleMode
        },
        links() {
            const links = [
                {
                    path: '/do-not-sell-my-personal-information/',
                    text: 'Do Not Sell My Personal Information',
                },
            ]

            if (this.isSimpleMode)
                links.push({
                    path: this.$config.runtime.theme.privacyUrl,
                    text: 'Privacy Policy',
                })
            else links.push(...this.$config.runtime.theme.footer.legalBar.links)

            return links
        },
    },
}
</script>
